export function SVG_ShiftX(x, svgElement) {
  var dx = svgElement["dx"];
  if (dx != null) x += dx;

  return x;
}
